import { Button } from "antd";
import { createElement, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { message, notification } from "shared/lib/antd-global";
import { markPushReminded, shouldRemindAboutPush } from "../lib/prompt-storage";
import { enablePush, getPushPermission, isPushAvailable } from "../lib/push";

const NOTIFICATION_KEY = "push-reminder";

/**
 * Напоминание о пушах при заходе на главную —
 * не чаще раза в PUSH_REMIND_INTERVAL_DAYS дней и только если пуши не включены.
 */
export const usePushReminder = () => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!isPushAvailable()) {
      return;
    }

    let cancelled = false;

    const enable = async () => {
      notification.destroy(NOTIFICATION_KEY);
      try {
        const result = await enablePush();
        if (result === "granted") {
          message.success(t("push.enabled"));
        }
      } catch (error) {
        console.error("[push] enable failed", error);
        message.error(t("push.error"));
      }
    };

    getPushPermission()
      .then((permission) => {
        if (cancelled || !shouldRemindAboutPush(permission)) {
          return;
        }

        markPushReminded(permission);

        if (permission === "denied") {
          notification.info({
            key: NOTIFICATION_KEY,
            title: t("push.denied_title"),
            description: t("push.denied_description"),
            duration: 0,
          });
          return;
        }

        notification.info({
          key: NOTIFICATION_KEY,
          title: t("push.title"),
          description: t("push.description"),
          duration: 0,
          actions: createElement(
            Button,
            { type: "primary", size: "small", onClick: enable },
            t("push.enable"),
          ),
        });
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [t]);
};
